import { render, staticRenderFns } from "./Appreciation.vue?vue&type=template&id=126fa640&scoped=true"
import script from "./Appreciation.vue?vue&type=script&lang=js"
export * from "./Appreciation.vue?vue&type=script&lang=js"
import style0 from "./Appreciation.vue?vue&type=style&index=0&id=126fa640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126fa640",
  null
  
)

export default component.exports